<template>
  <v-container class="gestao">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <PageTitle
          icon="mdi-pencil-box-outline"
          main="Gestão"
          sub="Cadastro de Gestão Administrativa"
          home='/gestao-da-camara'
        />
        <input
          id="user-id"
          type="hidden"
          v-model="gestao.usuario"
        />
        <input
          id="gestao-id"
          type="hidden"
          v-model="gestao.id"
        />
        <input
          id="gestao-uuid"
          type="hidden"
          v-model="gestao.uuid"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="gestao.inativar"
              label="Inativar gestão?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="gestao.ds_gestao"
              label="Descrição da gestão"
              required
              dense
              outlined
              hint="Gestão administrativa para mandato de 4 anos."
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="dtin"
                  v-model="data_ini"
                  label="Data início da gestão.:"
                  dense
                  outlined
                  @blur="mudaData"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date4"
                @input="dateB"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="dtfi"
                  v-model="data_fim"
                  label="Data fim da gestão.:"
                  dense
                  outlined
                  @blur="mudaDataA"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date1"
                @input="dateA"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab>
              <v-icon class="mr-1">
                mdi-history
              </v-icon>
              Histórico
            </v-tab>
            <v-tab @click="loadGestores">
              <v-icon class="mr-1">
                mdi-account-tie-outline
              </v-icon>
              Gestores
            </v-tab>
            <v-tab @click="loadDiretorias">
              <v-icon class="mr-1">
                mdi-account-group-outline
              </v-icon>
              Secretarios
            </v-tab>
            <v-tab @click="loadComissoes">
              <v-icon class="mr-1">
                mdi-account-group-outline
              </v-icon>
              Conselhos e Coms.
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-card-title class="headline">
                  Histórico
                </v-card-title>
                <v-textarea
                  v-model="gestao.html_gestao"
                  solo
                  dense
                  outlined
                  label="Histórico"
                ></v-textarea>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersGestores"
                        :items="vereadores"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadGestor(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            disabled="diasable"
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddVereador"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add Gestor
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersDiretorias"
                        :items="diretorias"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadDiretoria(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadDiretoria(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddDiretoria"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add diretoria
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersComissoes"
                        :items="comissoes"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            large
                            color="success"
                            class="mr-2"
                            @click="loadPageComissao(item)"
                          >
                            mdi-arrow-right-bold-box
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="addComissao"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add comissão
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-1">
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              :disabled="!valid"
              color="success"
              class="ml-1 mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar gestoes
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="gestoes"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadgestao(item, 'addhistorico')"
                    >
                      mdi-arrow-collapse-down
                    </v-icon>
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadgestao(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadgestao(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="DialogVereador"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <v-form
              v-model="valid"
              ref="form"
              class="altura"
            >
              <PageTitle
                icon="mdi-pencil-box-outline"
                sub="Adicionar vereador"
              />
              <input
                id="user-id"
                type="hidden"
                v-model="vereador.usuario"
              />
              <input
                id="vereador-id"
                type="hidden"
                v-model="vereador.id"
              />
              <input
                id="vereador-uuid"
                type="hidden"
                v-model="vereador.uuid"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                  class="mr-0 pr-0"
                >
                  <v-text-field
                    class="codigo mr-0"
                    v-model="vereador.uid_pessoa"
                    label="Código..."
                    dense
                    outlined
                    flat
                    @change="loadPedidoPessoaId()"
                  >
                    <v-icon
                      class="v-icon-btn-outer"
                      slot="append-outer"
                      color="white"
                      large
                      @click="loadFtPessoa"
                    >
                      mdi-magnify
                    </v-icon>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="5"
                  class="mx-0 px-0"
                >
                  <v-text-field
                    class="v-busca-nome ml-0"
                    v-model="vereador.vereador"
                    :loading="loading"
                    aria-autocomplete="none"
                    :search-input.sync="search"
                    label="Nome de batismo"
                    outlined
                    dense
                    @keyup.native="loadSeach()"
                  >
                    <v-icon
                      slot="prepend"
                      color="white"
                      @click="loadAddPessoa"
                      class="v-icon-btn"
                      large
                    >
                      mdi-plus
                    </v-icon>
                    <v-icon
                      v-if="vereador.vereador"
                      slot="append"
                      color="black"
                      @click.prevent="clPessoa"
                    >
                      mdi-close
                    </v-icon>
                  </v-text-field>
                  <v-card
                    v-show="listar === 'sim'"
                    class="my-0 py-0"
                  >
                    <ul class="filtro">
                      <li
                        v-for="item in items"
                        :key="item.id"
                      >
                        <a @click="loadPedidoPessoaId( item, 'novo' )"> {{ item.vereador }}</a>
                      </li>
                    </ul>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-autocomplete
                    v-model="vereador.uid_partido"
                    :items="partidos"
                    required
                    dense
                    outlined
                    label="Partido do vereador"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  lg="2"
                >
                  <v-autocomplete
                    v-model="vereador.uid_cargo"
                    :items="cargos"
                    required
                    dense
                    outlined
                    label="Cargo do vereador"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="7"
                  lg="5"
                >
                  <v-text-field
                    v-model="vereador.nome"
                    type="text"
                    label="Nome de campanha"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions class="justify-center">
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                type="submit"
                @click="adicionarVereador"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                type="submit"
                @click="adicionarVereadorSair"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="codigo"
                @click="limpar"
              >
                Limpar
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog de comissões permanentes -->
      <v-container>
        <v-dialog
          v-model="DialogComissoes"
          transition="dialog-bottom-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <PageTitle
              icon="mdi-pencil-box-outline"
              sub="Comissões"
            />
            <input
              id="user-id"
              type="hidden"
              v-model="comissao.usuario"
            />
            <input
              id="comissao-id"
              type="hidden"
              v-model="comissao.id"
            />
            <input
              id="comissao-uuid"
              type="hidden"
              v-model="comissao.uuid"
            />
            <input
              id="comissao-uuid"
              type="hidden"
              v-model="comissao.uid_mandato"
            />
            <v-row>
              <v-col
                cols="12"
                md="2"
              >
                <v-text-field
                  v-model="cdComissao"
                  label="Código"
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                lg="2"
              >
                <v-menu
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-mask="datapub"
                      v-model="data_pub"
                      label="Data de cadastro.:"
                      dense
                      outlined
                      @blur="mudaDataE"
                    >
                      <v-icon
                        slot="append"
                        color="success"
                        large
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-calendar
                      </v-icon>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    locale="pt-br"
                    v-model="date4"
                    @input="dateE"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                md="2"
                lg="2"
              >
                <v-text-field
                  v-model="comissao.ano_inicio"
                  label="Ano inicial.:"
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                lg="2"
              >
                <v-text-field
                  v-model="comissao.ano_termino"
                  label="Ano final.:"
                  dense
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                v-if="codigo"
              >
                <v-checkbox
                  v-model="comissao.inativar"
                  label="Inativar comissão?"
                  color="success"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="3"
                lg="2"
              >
                <v-text-field
                  v-model="comissao.nome"
                  label="Nome"
                  dense
                  outlined
                  hint="Exemplo: CJR, caixa alta"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                lg="3"
              >
                <v-autocomplete
                  clearable
                  dense
                  outlined
                  label="Biênio"
                  v-model="comissao.uid_bienio"
                  :items="bienios"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="9"
                lg="10"
              >
                <v-text-field
                  v-model="comissao.titulo"
                  label="Título"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="!comissao.id"
                @click="saveComissao"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="success"
                class="ml-1 mr-4"
                v-if="comissao.id"
                @click="saveComissao"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="comissao.id"
                @click="remove"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Deletar
              </v-btn>
              <v-btn
                color="secondary"
                class="mr-4"
                @click="limparComissao"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                Limpar
              </v-btn>
              <v-btn
                color="error"
                @click="closeDialogComissoes()"
              >Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="DialogDiretoria"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <v-form
              v-model="valid"
              ref="form"
              class="altura"
            >
              <PageTitle
                icon="mdi-pencil-box-outline"
                sub="Adicionar mesa diretora"
              />
              <input
                id="user-id"
                type="hidden"
                v-model="diretoria.usuario"
              />
              <input
                id="diretoria-id"
                type="hidden"
                v-model="diretoria.id"
              />
              <input
                id="diretoria-uuid"
                type="hidden"
                v-model="diretoria.uuid"
              />
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="diretoria.diretoria"
                    label="Título da diretoria"
                    required
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dtinc"
                        v-model="data_inic"
                        label="Data início da diretoria.:"
                        dense
                        outlined
                        @blur="mudaDataC"
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date2"
                      @input="dateC"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="dtfic"
                        v-model="data_fimc"
                        label="Data fim da diretoria.:"
                        dense
                        outlined
                        @blur="mudaDataD"
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date3"
                      @input="dateD"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="3"
                >
                  <v-text-field
                    v-model="diretoria.bienio"
                    label="Biênio da diretoria"
                    required
                    dense
                    outlined
                    hint="Ex: 1º biênio ou 2º biênio"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions class="justify-center">
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                type="submit"
                @click="saveDiretoria"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="codigo"
                @click="limpar"
              >
                Limpar
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'gestao',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    datapub: '##/##/####',
    dtin: '##/##/####',
    dtfi: '##/##/####',
    dtinc: '##/##/####',
    dtfic: '##/##/####',
    tabs: null,
    codigo: '',
    cdComissao: '',
    dialog: false,
    DialogVereador: false,
    DialogDiretoria: false,
    DialogComissoes: false,
    loading: false,
    search: null,
    select: null,
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    date3: new Date().toISOString().substr(0, 10),
    date4: new Date().toISOString().substr(0, 10),
    data_pub: '',
    data_ini: '',
    data_fim: '',
    data_inic: '',
    data_fimc: '',
    menu: false,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    mode: 'save',
    listar: '',
    gestao: {},
    vereador: {},
    diretoria: {},
    pessoa: {},
    comissao: {},
    items: [],
    cargos: [],
    vereadores: [],
    diretorias: [],
    gestoes: [],
    comissoes: [],
    partidos: [],
    length: '',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Gestao', value: 'ds_gestao' },
      { text: 'Início', value: 'inicio' },
      { text: 'Término', value: 'fim' },
      { text: 'Situação', value: 'status', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersComissoes: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome abrev', value: 'nome' },
      { text: 'Título', value: 'titulo' },
      { text: 'Biênio', value: 'bienio' },
      { text: 'Início', value: 'ano_inicio' },
      { text: 'Término', value: 'ano_termino' },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersGestores: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'uidAgente'
      },
      { text: 'Agente', value: 'agente' },
      { text: 'Cargo', value: 'cargo' },
      { text: 'Unidade', value: 'unidade' },
      { text: 'Início', value: 'dtini' },
      { text: 'Término', value: 'dtfim', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersDiretorias: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Mesa diretora', value: 'diretoria' },
      { text: 'Biênio', value: 'bienio' },
      { text: 'Início', value: 'dtini' },
      { text: 'Término', value: 'dtfim', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    bienios: [
      { value: 1, text: '1º Biênio' },
      { value: 2, text: '2º Biênio' }
    ],
    valid: false
  }),
  methods: {
    dateB () {
      this.data_ini = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaData () {
      const [dia, mes, ano] = this.data_ini.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateA () {
      this.data_fim = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
    },
    mudaDataA () {
      const [dia, mes, ano] = this.data_fim.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateC () {
      this.data_inic = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
    },
    mudaDataC () {
      const [dia, mes, ano] = this.data_inic.split('/')
      this.date2 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateD () {
      this.data_fimc = moment(this.date3).format('DD/MM/YYYY')
      this.menu3 = false
    },
    mudaDataD () {
      const [dia, mes, ano] = this.data_fimc.split('/')
      this.date3 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateE () {
      this.data_pub = moment(this.date4).format('DD/MM/YYYY')
      this.menu4 = false
    },
    mudaDataE () {
      const [dia, mes, ano] = this.data_pub.split('/')
      this.date4 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    endereco () {

    },
    fone () {

    },
    histori () {

    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      this.gestao.data_inicio = this.date
      this.gestao.data_termino = this.date1
      const method = this.gestao.id ? 'put' : 'post'
      const id = this.gestao.id ? `/${this.gestao.id}` : ''
      axios[method](`${baseApiUrl}/gestao${id}`, this.gestao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    saveVereador () {
      const method = this.vereador.id ? 'put' : 'post'
      const id = this.vereador.id ? `/${this.vereador.id}` : ''
      axios[method](`${baseApiUrl}/vereadores${id}`, this.vereador)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadGestores()
        })
        .catch(showError)
    },
    saveDiretoria () {
      this.diretoria.data_inicio = this.date2
      this.diretoria.data_termino = this.date3
      const method = this.diretoria.id ? 'put' : 'post'
      const id = this.diretoria.id ? `/${this.diretoria.id}` : ''
      axios[method](`${baseApiUrl}/diretorias${id}`, this.diretoria)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadDiretorias()
          this.DialogDiretoria = false
        })
        .catch(showError)
    },
    saveComissao () {
      this.comissao.data_publicacao = this.date4
      const method = this.comissao.id ? 'put' : 'post'
      const id = this.comissao.id ? `/${this.comissao.id}` : ''
      axios[method](`${baseApiUrl}/admin-comissoes-permanentes${id}`, this.comissao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparComissao()
          this.loadComissoes()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadGestores () {
      const id = this.gestao.id
      const url = `${baseApiUrl}/equipe-administrativa/${id}`
      axios.get(url).then(res => {
        this.vereadores = res.data.map(item => {
          return {
            ...item,
            dtini: moment(item.data_inicio).format('DD/MM/YYYY'),
            dtfim: moment(item.data_termino).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadComissoes () {
      const id = this.gestao.id
      const url = `${baseApiUrl}/comissoes-permanentes-por-mandato/${id}`
      axios.get(url).then(res => {
        this.comissoes = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadPageComissao (item) {
      this.$router.push({
        name: 'viewConsCom',
        params: { id: item.id }
      })
    },
    loadDiretorias () {
      const id = this.gestao.id
      const url = `${baseApiUrl}/diretorias-do-mandato/${id}`
      axios.get(url).then(res => {
        this.diretorias = res.data.map(item => {
          return {
            ...item,
            dtini: moment(item.data_inicio).format('DD/MM/YYYY'),
            dtfim: moment(item.data_termino).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadGestoes () {
      const url = `${baseApiUrl}/gestao-filtro`
      axios.get(url).then(res => {
        this.gestoes = res.data.map(item => {
          return {
            ...item,
            inicio: moment(item.data_inicio).format('DD/MM/YYYY'),
            fim: moment(item.data_termino).format('DD/MM/YYYY'),
            status: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadgestao (item, mode = 'save') {
      const id = this.codigo | item.id
      const url = `${baseApiUrl}/gestao-update/${id}`
      axios.get(url).then(res => {
        this.gestao = res.data
        this.data_ini = moment(this.gestao.data_inicio).format('DD/MM/YYYY')
        this.data_fim = moment(this.gestao.data_termino).format('DD/MM/YYYY')
        this.codigo = this.gestao.id
      })
      this.mode = mode
      this.dialog = false
      this.valid = true
      this.loadDatas()
    },
    loadPedidoPessoaId (item) {
      const id = this.vereador.uid_pessoa ? `/${this.vereador.uid_pessoa}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/vereador-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.vereador.uid_pessoa = this.pessoa.uid_pessoa
        this.vereador.vereador = this.pessoa.vereador
        this.vereador.cpf = this.pessoa.cpf
        this.vereador.cpf_txt = this.pessoa.cpf_txt
      })
      this.clPessoa()
    },
    clPessoa () {
      this.vereador.uid_pessoa = ''
      this.vereador.vereador = ''
      this.vereador.cpf = ''
      this.vereador.cpf_txt = ''
      this.items = []
      this.listar = ''
    },
    loadSeach (listar = 'sim') {
      const search = this.vereador.vereador || 0
      const url = `${baseApiUrl}/vereador-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {

    },
    loadGestor () {

    },
    loadDiretoria () {

    },
    AddVereador () {
      this.loadPartidos()
      this.loadCargos()
      this.vereador.usuario = this.user.id
      this.vereador.uid_mandato = this.gestao.id
      this.vereador.uuid = uuid.v1()
      this.DialogVereador = true
    },
    AddDiretoria () {
      this.loadPartidos()
      this.diretoria.usuario = this.user.id
      this.diretoria.uid_mandato = this.gestao.id
      this.diretoria.uuid = uuid.v1()
      this.DialogDiretoria = true
    },
    addComissao () {
      this.initComissao()
      this.DialogComissoes = true
    },
    reset () {
      this.$refs.form.reset()
      this.valid = true
      this.mode = 'save'
      this.gestao = {}
      this.codigo = ''
      this.cdComissao = ''
      this.comissoes = []
      this.vereadores = []
      this.loadUser()
    },
    limpar () {
      this.mode = 'save'
      this.vereador = {}
      this.diretoria = {}
    },
    FecharDialog () {
      this.DialogVereador = false
      this.DialogDiretoria = false
      this.limpar()
    },
    adicionarVereador () {
      this.saveVereador()
    },
    adicionarVereadorSair () {
      this.saveVereador()
      this.DialogVereador = false
    },
    loadDialog () {
      this.dialog = true
      this.loadGestoes()
    },
    loadPartidos () {
      const url = `${baseApiUrl}/partidos`
      axios.get(url).then(res => {
        this.partidos = res.data.map(partidos => {
          return {
            value: partidos.id,
            text: `${partidos.partido}`
          }
        })
      })
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.cargos = res.data.map(cargos => {
          return {
            value: cargos.id,
            text: `${cargos.cargo}`
          }
        })
      })
    },
    closeDialogComissoes () {
      this.DialogComissoes = false
    },
    limparComissao () {
      this.comissao = {}
      this.cdComissao = ''
      this.initComissao()
      this.loadDatas()
    },
    initComissao () {
      this.comissao.uid_mandato = this.gestao.id
      this.comissao.usuario = this.user.id
      this.comissao.uuid = uuid.v1()
    },
    loadDatas () {
      this.mudaData()
      this.mudaDataA()
      this.mudaDataE()
    },
    loadUser () {
      this.gestao.usuario = this.user.id
      this.gestao.uuid = uuid.v1()
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.altura {
  min-height: 380px !important;
}
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}
.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 750px;
}
</style>
